(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/pix-item/assets/javascripts/pix-item.js') >= 0) return;  svs.modules.push('/components/tipsen/pix-item/assets/javascripts/pix-item.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const _svs$components$tipse = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse.useBranding,
  useIsDrawPlayable = _svs$components$tipse.useIsDrawPlayable;
const usePlaceBet = svs.components.sport.quickplayModal.placeBet.usePlaceBet;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG;
const Shield = svs.components.lbUi.shield.Shield;
const analytics = svs.components.analytics;
const products = svs.utils.products;
const QuickplayModal = svs.components.sport.quickplayModal.QuickplayModal;
const resolveCompetitionYear = svs.components.marketplaceCompetition.helpers.resolveCompetitionYear;
const CompetitionType = svs.components.marketplaceCompetition.constants.CompetitionType;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const FirstBannerText = () => React.createElement(React.Fragment, null, React.createElement("span", {
  className: "f-bold"
}, "PIX! "), React.createElement("span", {
  className: "f-normal"
}, "F\xE4rdiga spel."));
const SecondBannerText = () => {
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  if (isWideDevice) {
    return React.createElement(React.Fragment, null, "\xA0", React.createElement("span", {
      className: "f-normal"
    }, "Helt enkelt."));
  }
  return React.createElement("span", {
    className: "f-normal block"
  }, "Helt enkelt.");
};
const BuyBannerText = () => React.createElement("p", null, React.createElement(FirstBannerText, null), React.createElement(SecondBannerText, null));
const PayButton = _ref => {
  var _svs$core$config$data;
  let isDisabled = _ref.isDisabled,
    drawNumber = _ref.drawNumber,
    payButtonClassNames = _ref.payButtonClassNames,
    productId = _ref.productId,
    systemCost = _ref.systemCost,
    wallet = _ref.wallet,
    rowPrice = _ref.rowPrice,
    branding = _ref.branding;
  const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
  const _usePlaceBet = usePlaceBet(),
    placeBet = _usePlaceBet.placeBet;
  const handlePayButtonClick = useCallback(async event => {
    if (!isDisabled) {
      event.stopPropagation();
      const _await$svs$components = await svs.components.sport.quickplayModal.services.fetchDrawAndPix({
          productId,
          drawNumber,
          systemCost,
          rowPrice,
          branding,
          isPixMix: false
        }),
        drawResponse = _await$svs$components.drawResponse;
      placeBet({
        productId,
        drawData: drawResponse,
        wallet,
        isPixMix: false
      });
    }
  }, [isDisabled, productId, placeBet, wallet, systemCost, rowPrice, branding, drawNumber]);
  const handlePayButtonKeyDown = useCallback((event, key) => {
    event.stopPropagation();
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handlePayButtonClick(event);
    }
  }, [handlePayButtonClick]);
  return React.createElement("button", {
    className: payButtonClassNames,
    "data-testid": "tipsen-pix-item-pay-button",
    disabled: isDisabled,
    onClick: handlePayButtonClick,
    onKeyDown: handlePayButtonKeyDown,
    type: "button"
  }, isSelfService ? 'Lägg i varukorg' : 'Köp');
};
const PixItem = _ref2 => {
  let draw = _ref2.draw,
    competitionBranding = _ref2.competitionBranding,
    drawNumber = _ref2.drawNumber,
    index = _ref2.index,
    isCompetition = _ref2.isCompetition,
    productId = _ref2.productId,
    systemCost = _ref2.systemCost,
    wallet = _ref2.wallet,
    competitionType = _ref2.competitionType,
    rowPrice = _ref2.rowPrice;
  const isDrawPlayable = useIsDrawPlayable(productId, drawNumber);
  const disablePixItem = !isDrawPlayable;
  const pixItemClassNames = ['pg_pix'];
  const showDetailsClassNames = ['pg_pix__buy_banner__details'];
  const pixItemRef = useRef();
  const initiator = useRef();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  pixItemClassNames.push("pg_pix--".concat(branding));
  if (disablePixItem) {
    pixItemClassNames.push('pg_pix--disabled');
    showDetailsClassNames.push('pg_pix__buy_banner__details--disabled');
  } else {
    pixItemClassNames.push('elevation-100', 'clickable-magnetic');
  }
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showQuickPlay = _useState2[0],
    setShowQuickPlay = _useState2[1];
  const handleClick = useCallback(() => {
    if (!disablePixItem) {
      const productName = products.getProductClassName(productId);
      analytics.trackEvent({
        category: 'Widget banner',
        action: 'Details',
        opt_label: "".concat(productName, "-").concat(systemCost)
      });
      setShowQuickPlay(true);
    }
  }, [disablePixItem, productId, systemCost]);
  const handleKeyDown = useCallback(key => {
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handleClick();
    }
  }, [handleClick]);
  const onModalClose = useCallback(() => {
    setShowQuickPlay(false);
  }, []);
  useEffect(() => {
    const element = pixItemRef.current;
    element.addEventListener('tipsenOpenPixModal', handleClick);
    return () => element.removeEventListener('tipsenOpenPixModal', handleClick);
  }, [handleClick]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "aria-labelledby": "pg-pix__item_".concat(index),
    className: pixItemClassNames.join(' '),
    "data-pix-amount": systemCost,
    id: "pg-pix__item_".concat(index),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: pixItemRef,
    role: "group"
  }, React.createElement("div", {
    className: "pg_pix__details_banner"
  }, React.createElement("div", {
    className: "pg_pix__details_banner__splash"
  }), isCompetition ? React.createElement(Shield, {
    className: "shield-pix shield-large pg_pix__details_banner__shield ".concat(competitionType === 'TipsEM' ? 'shield-green-white shield-green-white-pix' : ''),
    options: {
      hasLaurel: true
    }
  }, React.createElement("span", {
    className: "shield-unit pg_pix__details_banner__shield_unit"
  }, competitionType === 'TipsEM' ? 'Europatips-mästaren' : 'Tips-SM ', ' ', competitionType === CompetitionType.TipsSM ? resolveCompetitionYear(competitionType) : ''), React.createElement("span", {
    className: "shield-value pg_pix__details_banner__shield_value"
  }, "".concat(systemCost, " kr"))) : React.createElement("h3", {
    className: "pg_pix__details_banner__pix_size"
  }, "".concat(systemCost, " kr"))), React.createElement("div", {
    className: "pg_pix__buy_banner"
  }, React.createElement("div", {
    className: "pg_pix__buy_banner__text"
  }, React.createElement(BuyBannerText, null)), React.createElement(PayButton, {
    branding: branding,
    drawNumber: drawNumber,
    isDisabled: disablePixItem,
    payButtonClassNames: "btn btn-default pg_pix__buy_banner__button ".concat(isCompetition ? "pg_pix__buy_banner__button--".concat(competitionType.toLowerCase()) : ''),
    productId: productId,
    rowPrice: rowPrice,
    systemCost: systemCost,
    wallet: wallet
  }), React.createElement("button", {
    className: showDetailsClassNames.join(' '),
    ref: initiator,
    type: "button"
  }, "Visa detaljer"))), showQuickPlay && React.createElement(QuickplayModal, {
    branding: branding,
    competitionBranding: competitionBranding,
    drawNumber: drawNumber,
    hasPortal: true,
    initiator: initiator.current,
    onModalClose: onModalClose,
    productId: productId,
    rowPrice: 1,
    systemCost: systemCost,
    wallet: wallet
  }));
};
setGlobal('svs.components.tipsen.pixItem.PixItem', PixItem);

 })(window);